import React from "react";
import requestAnimated from "../../assets/img/request/callback_animated.png";
import requestRightBg from "../../assets/img/request/callback_bg.png";

export const RequestAreaTwo = () => {
  return (
    <section className="request-area-two">
      <div
        className="request-shape-right"
        data-aos="fade-left"
        data-aos-delay="200"
        style={{ backgroundImage: `url(${requestRightBg})` }}
      ></div>
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6">
            <div className="request-content-two">
              <div className="section-title-two white-title mb-15 tg-heading-subheading animation-style3">
                <h2 className="title tg-element-title">Get Your Free Books Health Check</h2>
              </div>
              <p>
              Tell us a little about your business and we'll call you within one business day. No obligation.
              </p>
            </div>
          </div>

          <div className="col-lg-6">
            <div className="request-form-wrap">
              <form action="#">
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-grp">
                      <input type="text" placeholder="Name *" />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-grp">
                      <input type="email" placeholder="E-mail *" />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-grp">
                      <input type="number" placeholder="Phone *" />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <button type="submit">Request my Free Call</button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div className="request-shape-wrap">
        <img src={requestAnimated} alt="" />
      </div>
    </section>
  );
};
